import { OrganizationVideo } from 'lib/api/organizationVideo/useOrganizationVideoQuery';
import { ParagraphNormal } from 'lib/components/styles/typography';
import React from 'react';
import { NewModal } from '../NewModal';

type ModalProps = {
  handleModalClose: () => void;
  organizationVideo: OrganizationVideo;
};

export const ModalOrganizationVideoDetails = ({
  handleModalClose,
  organizationVideo,
}: ModalProps) => {
  return (
    <NewModal
      closeModal={handleModalClose}
      headerText={organizationVideo.title}
      style={{
        content: { maxWidth: '900px' },
      }}
    >
      <ParagraphNormal style={{ whiteSpace: 'pre-wrap' }}>
        {organizationVideo.description}
      </ParagraphNormal>
    </NewModal>
  );
};
